import { i18n } from 'src/boot/i18n'

export default function useI18n() {
  return i18n.global
}
